import React, { useState, useEffect } from 'react';
import { ReactInternetSpeedMeter } from 'react-internet-meter'

const SpeedTester = ({callbackFunctionOnNetworkTest}) => {

 
   
  return (
      <ReactInternetSpeedMeter
        txtMainHeading="" 
        txtSubHeading=""
        outputType="alert"
        customClassName={null}
        pingInterval={4000} // milliseconds 
        thresholdUnit='megabyte' // "byte" , "kilobyte", "megabyte" 
        threshold={100}
        imageUrl="https://e-notary-s3.s3.ap-southeast-1.amazonaws.com/1mb.jpg"
        downloadSize="1781287"  //bytes
        callbackFunctionOnNetworkDown={(speed)=>console.log(`Internet speed is down ${speed}`)}
        callbackFunctionOnNetworkTest={callbackFunctionOnNetworkTest}
      />
  );
};

export default SpeedTester;
